(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('system', {
            parent: 'module',
            url: '/system',
            data: {
                authorities: ['ROLE_SYSTEM_SETTING']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/system/system.html',
                    controller: 'SystemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
    }
})();
